import type { Tag } from '@/services/forms/tmTiptap/types'
import type { CascadeMenuItem } from '@/components/shared/TmCascadeMenu/types'

export const tagsToCascadeMenu = (tags: Tag[]): CascadeMenuItem[] =>
  tags.map((tag) => ({
    type: 'item',
    value: tag.title,
    label: tag.title,
    description: `{${tag.title}}`,
    icon: tag.icon,
  }))
